var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M255.1,279.7c-66.8,3-133.6-46.6-138.1-126.1c-4-70.9,48.1-130.7,116.6-139C311.9,5.2,378.9,62.9,383,140.3 C386.8,210.7,332.6,276.5,255.1,279.7z M348.4,148.1c1.5-51.6-41.4-97.6-91.7-100c-60.5-2.8-105.3,44.5-105.5,98.8 c-0.2,50.2,42.3,96.2,92,98.5C303.9,248.2,348.8,200.9,348.4,148.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.1,326c91.6,5.4,159.7,39.9,211.3,106c6.2,8,11.3,16.8,16.7,25.4c6.6,10.5,4.9,21-4.1,26.6 c-8.3,5.2-17.8,1.3-25-8.6c-10.9-15-21.5-30.4-34-43.9c-27.1-29.3-60.5-49.1-98.8-60.4c-57-16.9-112.6-12.4-166.1,13.4 c-42.2,20.4-75.1,51.1-98.5,91.9c-5.4,9.5-15,12.7-23.8,8c-9.4-5-12.5-13.9-7.2-23.9c11.5-21.5,26.7-40.1,44-57.1 c37.8-37.2,82.7-61.4,134.8-71.3C218.6,328.2,238.4,327.3,250.1,326z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.381b115a0c34906eb49133d21129f030.svg";
export { ForwardRef as ReactComponent };